import {useContext} from "react";
import {ToastContext} from "../Contexts";
import {
    FilterBaseRequest, ListFilterResponse,
    ToastFailureMessage,
} from "../Models/Models";
import HttpRepository from "./HttpRepository";

export function ListService() {
    let {setToast}: any = useContext(ToastContext);

    async function filterLists(request: FilterBaseRequest): Promise<ListFilterResponse> {
        try {
            return (await HttpRepository.filterLists(request)).data;
        } catch (error) {
            setToast({message: ToastFailureMessage.dataNotLoaded});
        }
    }

    return {filterLists}
}